import React, { FC } from 'react';
import styled from 'styled-components';
import { Flexbox, FlexboxCenter, FlexboxVertical, FlexContainer } from '../Layout';
import { Colors } from '../../../styles/colors';
import { Headline6, TextDefault } from '../Text';
import { Icon } from '../Icon';
import { ProductIconWrapper, ProductItemType } from './icons/ProductIconWrapper';
import { AnimatedContainer, AnimatedContainerProps } from '../AnimatedContainer';

const Container = styled(AnimatedContainer)`
  cursor: pointer;
`;

const ContentWrapper = styled.div`
  position: relative;
  padding-top: 59%;
`;

const Content = styled(FlexboxVertical)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  background-color: ${Colors.grayDark};
  color: ${Colors.white};
  padding: 1.25rem;
  
  ${TextDefault} {
    @media (max-width: 1199px) {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
`;

const ImageWrapper = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 50%;
  height: 50%;
  object-fit: contain;
  object-position: bottom right;
  
  svg {
    height: 100%;
    max-width: 100%;
    margin-left: auto;
    
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;  
  }
`;

const Button = styled(Flexbox)<{bordered: boolean}>`
  padding: 1rem 1.25rem;
  background-color: ${Colors.white};
  color: ${Colors.grayDark};
  border: ${ (props) => props.bordered ? `1px solid ${Colors.grayDark}` : 'none' }
`;

const ChevronIconWrapper = styled(FlexboxCenter)`
  width: 1rem;
  height: 1rem;
  transform: rotate(-90deg);
`;

interface Props extends AnimatedContainerProps {
  onClick?: () => void;
  type: ProductItemType;
  color?: string;
  additionalListItem?: boolean;
}
export const ProductItem: FC<Props> = ({ onClick, type, color, animationActive, animationDelay, children, ...props }) => {
  const { additionalListItem = false } = props;

  return (
    <Container onClick={onClick} active={animationActive} delay={animationDelay}>
      <ContentWrapper>
        <Content>
          <TextDefault title={typeof children === 'string' && children}>{ children }</TextDefault>
          <ImageWrapper>
            <ProductIconWrapper type={type} color={color || Colors.white} />
          </ImageWrapper>
        </Content>
      </ContentWrapper>
      <Button bordered={additionalListItem}>
        <FlexContainer>
          <Headline6>Zum Produkt</Headline6>
        </FlexContainer>
        <ChevronIconWrapper>
          <Icon icon={'chevron'} size={16} />
        </ChevronIconWrapper>
      </Button>
    </Container>
  );
}
